import { Link, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getPrincipalMessage } from "../Service/Api";
import LazyLoad from "react-lazyload";
import React from "react";

function MessageInner() {
  const { category } = useParams();

  // Convert "vice-principal" -> "Vice Principal"
  const formattedCategory = category
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  const {
    data = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["principalMessage", formattedCategory],
    queryFn: () => getPrincipalMessage(formattedCategory),
    queryFn: async () => {
      const allMessages = await getPrincipalMessage(); // fetch all messages
      return allMessages.filter((msg) => msg.category === formattedCategory);
    },
    enabled: !!formattedCategory,
  });

  return (
    <>
      <div className="innerslide py-3 bg-light border-bottom">
        <ul className="breadcrumb container mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item active">
            {formattedCategory} Message
          </li>
        </ul>
      </div>

      {/* Main inner section */}
      <div className="innersec container my-5">
        <div className="row">
          <div class="col-lg-12">
            <h1> {formattedCategory} </h1>
          </div>
          <div className="col-lg-12">
            {isLoading && <p className="text-center my-5">Loading...</p>}
            {isError && (
              <p className="text-center text-danger my-5">
                Error fetching message.
              </p>
            )}

            {!isLoading && (
              <>
                {data.length > 0 ? (
                  data.map((item, index) => (
                    <div className="clearfix" key={index}>
                      <LazyLoad
                        offset={10}
                        placeholder={
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/dummy.jpg"
                            alt="Loading..."
                            className="img-fluid"
                          />
                        }>
                        <img
                          src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments}`}
                          alt="Frank Anthony Bangalore"
                          className="col-md-4 float-md-end left-img img-fluid"
                        />
                      </LazyLoad>

                      <div
                        className="innermsg"
                        dangerouslySetInnerHTML={{ __html: item.message }}
                      />

                      <div className="mesdeskimg">
                        <h3>{item.name}</h3>
                        <h5>{formattedCategory}</h5>
                      </div>
                    </div>
                  ))
                ) : (
                  <>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/profilethumb.png"
                      className="col-md-4 float-md-end left-img img-fluid"
                      alt="Frank Anthony Bangalore"
                    />
                    <p>coming soon...</p>

                    <div className="mesdeskimg">
                      <h3>{formattedCategory} name</h3>
                      <h5>{formattedCategory}</h5>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default MessageInner;
